import { noop } from "lodash";
import { useContext, useEffect, useMemo, useState } from "react";
import { Subject } from "rxjs";
import { useFileLoader } from "../../../../../../../components/hooks/file-loader";
import { VerificationDTO } from "../../../../../../../store/verification/models/dto/due-diligence";
import { DueDiligenceFileCategory } from "../../../../../../../store/verification/models/internal";
import { VerificationService } from "../../../../../../../store/verification/service";
import { ConfigContext } from "../../../common/config-context";
import { AttachmentFormType } from "../../../common/pages/common/attachment";

export const useFileUploader = (
  category: typeof DueDiligenceFileCategory.T
) => {
  const {
    state: { contactEmail, dueDiligenceId },
  } = useContext(ConfigContext);
  const fileLoader = useFileLoader();
  const [uploaded, setUploaded] = useState(false);
  const subject = useMemo(() => new Subject<AttachmentFormType>(), []);
  const success = useMemo(
    () =>
      new Subject<VerificationDTO.Requests.DueDiligence.Form.Post.Attachments.T>(),
    []
  );

  useEffect(() => {
    const sub = subject.subscribe((data) => {
      if (dueDiligenceId && contactEmail) {
        fileLoader(
          VerificationService.postDueDiligenceFormAttachments(dueDiligenceId, {
            ...data,
            category,
            emailAddress: contactEmail,
            prevEmailAddress: contactEmail,
          })
        )
          .then(() => {
            setUploaded(true);
            success.next(data);
          })
          .catch(noop);
      }
    });

    return () => sub.unsubscribe();
  }, [contactEmail, dueDiligenceId, subject, category, success]);

  return [subject, uploaded, success] as const;
};
